var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveTransferTreatment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 24,
    height: 24,
    style: {
      borderColor: "rgba(0,0,0,0)",
      borderWidth: "bpx",
      borderStyle: "undefined"
    },
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.687l-11.313 11.313 11.313 11.313 11.313-11.313-11.313-11.313zM16.943 1.857l13.2 13.2c0.241 0.241 0.39 0.575 0.39 0.943s-0.149 0.701-0.39 0.943l-13.2 13.2c-0.241 0.241-0.575 0.39-0.943 0.39s-0.701-0.149-0.943-0.39l-13.2-13.2c-0.241-0.241-0.39-0.575-0.39-0.943s0.149-0.701 0.39-0.943l13.2-13.2c0.241-0.241 0.575-0.39 0.943-0.39s0.701 0.149 0.943 0.39v0zM17.333 13.333v-3.333l4.667 4.667-4.667 4.667v-3.333h-4v4h-2.667v-5.333c0-0.736 0.597-1.333 1.333-1.333v0h5.333z",
    fill: "rgba(204,204,204,1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTransferTreatment);
export default __webpack_public_path__ + "static/media/activeTransferTreatment.c7188826.svg";
export { ForwardRef as ReactComponent };